import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=6458657b&scoped=true&"
import script from "./OurTeam.vue?vue&type=script&lang=ts&"
export * from "./OurTeam.vue?vue&type=script&lang=ts&"
import style0 from "./OurTeam.vue?vue&type=style&index=0&id=6458657b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458657b",
  null
  
)

export default component.exports